import { useState } from "react";
import { ModalBase } from "../../../../components/Modals/ModalBase";
import { useDispatch } from "react-redux";
import { generalShowLoader } from "../../../../actions/general.actions";
import {
    mapeoRowJSONProductos,
    mapeoRowProductosXLSX,
    validRowProductos,
    normalizeDataKeys,
} from "../../../../utils/cargas.utils";
import * as XLSX from "xlsx";
import { setDataFileProductos } from "../../../../actions/gestion-producto/agregar-producto/agregarProductoFile.actions";
import {State} from '../../../../reducers'
import { useSelector } from "react-redux";

export default function ModalCargarFileProductos({ onClose, onAccept }: { onClose: any; onAccept: any; }) {
    const dispatch = useDispatch();

    const [fileName, setFileName] = useState("");
    const [dataFile, setDataFile] = useState<Array<any>>([]);
    const [fileExt, setFileExt] = useState("");
    const [error, setError] = useState("");
    const [warnEmpty, setWarnEmpty] = useState("");
    const [fileBase64, setFileBase64] = useState('');
    const { productosFileDataCargada = {} } = useSelector((state: State) => state.productos || {});
    const { dataFile: existingDataFile = [] } = productosFileDataCargada;


    const cleanAndMapData = (data: any, ext: string) => {
        const resultCountCleaned: number[] = [];
        let countIndex = ext === ".xlsx" ? 2 : 1;
        
        // Normaliza los nombres de las claves del encabezado si es un archivo XLSX
        const normalizedData = ext === ".xlsx" ? normalizeDataKeys(data) : data;

        // Filtra los datos para quedarte solo con las filas válidas
        const cleanedData = normalizedData.filter((row: any) => {
            const [valid, _] = validRowProductos(row, ext);
            if (!valid) {
                resultCountCleaned.push(countIndex);
            }
            countIndex++;
            return valid;
        });

        //Mapea y transforma las claves a la estructura final de tu aplicación
        let finalData: any[] = [];
        if (ext === ".xlsx") {
            finalData = mapeoRowProductosXLSX(cleanedData);
        } else if (ext === ".json") {
            finalData = mapeoRowJSONProductos(cleanedData);
        }

        return [finalData, resultCountCleaned];
    };

   const handleAccept = () => {
    if (!dataFile?.length) {
        setError('Por favor, cargar archivo para validar los datos');
        return;
    }
    if (warnEmpty) return;

    const mergedData = [...existingDataFile, ...dataFile];

    const payload = { 
        dataFile: mergedData, 
        fileBase64,
        form: {
            ext: fileExt,
            datosHacienda: mergedData,
            varianteCargaProductos: 'manual'
        }
    }
    dispatch(setDataFileProductos(payload));
    onAccept();
};

    const onChangeFile = async (e: any) => {
    try {
        dispatch(generalShowLoader(true));
        const files = e.target.files;
        if (!files.length) {
            setError("Por favor, seleccione un archivo.");
            return;
        }

        const file = files[0];
        const fileExtension = file.name.slice(file.name.lastIndexOf("."));
        const validTypes = [".xlsx", ".json"];

        if (!validTypes.includes(fileExtension.toLowerCase())) {
            setError("Por favor, selecciona un archivo con una extensión válida. (.xlsx, .json)");
            return;
        }
        
        setFileExt(fileExtension.toLowerCase())

        setFileName(file.name);
        setError("");

        const reader = new FileReader();
        reader.onload = (evt: any) => {
  const result = evt.target.result;
  const base64String = result.split(',')[1];
  setFileBase64(base64String);

  let parsedData: any = [];

  if (fileExtension === ".xlsx") {
    const wb = XLSX.read(base64String, { type: "base64" });
    const ws = wb.Sheets[wb.SheetNames[0]];
    parsedData = XLSX.utils.sheet_to_json(ws);
  } else {
    const jsonString = atob(base64String);
    parsedData = JSON.parse(jsonString);
  }

  const [dataClean, resultClean] = cleanAndMapData(parsedData, fileExtension);
  setDataFile(dataClean);
            if (resultClean.length > 0) {
                setWarnEmpty(`Alerta: Se detectaron en el documento ${resultClean.length} registros incorrectos. \nPor favor revisar el archivo de carga e intentar nuevamente. \nFilas con error: ${resultClean.join(", ")}.`);
            } else {
                setWarnEmpty("");
            }
        };

        reader.readAsDataURL(file);

    } catch (err) {
        setError("Ocurrió un error al cargar el archivo, intenta cargarlo nuevamente.");
    } finally {
        dispatch(generalShowLoader(false));
    }
};

    return (
        <ModalBase>
            <div className="dte-send-email-container">
                <div>
                    <h3 className="card-title">Cargar archivo de productos</h3>
                </div>
                <div className="separador" />
                <p className="m" style={{ fontWeight: "400", margin: "0" }}>
                    El formato XLSX se utiliza para cargar documentos. (Si necesita el formato, puede descargarlo en la pantalla previa).
                </p>
                <p className="m" style={{ fontWeight: "400", margin: "0" }}>
                    <b>Nota:</b> Al cargar un archivo en formato XLXS, asegúrese de que los datos estén con formato de texto para no sufrir alteraciones al realizar la carga.
                </p>
                <div className="w-layout-hflex h-inputs">
                    <div className="label-input">
                        <div className="file-input">
                            <input
                                autoComplete="off"
                                type="file"
                                className="text-field w-input upload_file_input file-input"
                                name="productosExcel"
                                id="productosExcel"
                                accept=".xlsx, .json"
                                onChange={onChangeFile}
                            />
                            <span className="m button">Seleccionar archivo</span>
                            <span className="label">
                                {fileName || "Ningún archivo seleccionado (.xlsx)"}
                            </span>
                        </div>
                        {error && <p className="alert s">{error}</p>}
                    </div>
                </div>
                {warnEmpty && <p className="alert s">{warnEmpty}</p>}
                <div className="dte-send-email-footer" style={{ marginTop: "16px" }}>
                    <button className="button transparent w-inline-block" onClick={onClose}>
                        Cancelar
                    </button>
                    <button type="button" className="button w-inline-block" onClick={handleAccept}>
                        Validar datos
                    </button>

                </div>
            </div>
        </ModalBase>
    );
}